import parsePhoneNumber from 'libphonenumber-js/min';

export enum PhoneMask {
  detailed,
  simple,
}

export const formatPhone = (phone: string, mask: PhoneMask) => {
  if (!/^\+/.test(phone)) phone = `+${phone}`;

  const phoneNumber = parsePhoneNumber(phone, { defaultCountry: 'RU' });

  if (!phoneNumber) return '';
  if (mask === PhoneMask.detailed) return phoneNumber.formatInternational();
  return phoneNumber.format('E.164');
};
export const checkPhoneIsValid = (phone: string) =>
  !!parsePhoneNumber(phone)?.isValid();

export const comparePhone = (phone1: string, phone2: string) =>
  formatPhone(phone1, PhoneMask.simple) ===
  formatPhone(phone2, PhoneMask.simple);
